export default __webpack_public_path__ + "static/media/InstagramAppIcon.0403ac0e.svg";